var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironnementRecto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 552 555.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#12171c;}.cls-1,.cls-5{stroke:#12171c;}.cls-1,.cls-3,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-2,.cls-3,.cls-6{fill:#fff;}.cls-3,.cls-6{stroke:#33163a;}.cls-4{fill:#dbf226;}.cls-5{fill:none;stroke-width:2px;}.cls-6{opacity:0.82;}.cls-7{fill:#052941;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "environnement recto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_7",
    "data-name": "Calque 7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 10,
    width: 550,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 1,
    width: 550,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.18,
    y: 17.54,
    width: 499.77,
    height: 452.46,
    rx: 28.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M657,1001c252.5,116.5,496-192,330-419.5l195,.5c17,1,29,11,25,34V850s-6.52,189-218.26,276.5C812,1126,682,1127,682,1127c-12,0-26-10-24-33Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.5,
    y: 1,
    width: 549.5,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 26.18,
    y: 17.54,
    width: 499.77,
    height: 452.46,
    rx: 28.07
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M836.06,1098v-20.58H839V1098Zm1.41-17.84v-2.74h11.82v2.74Zm0,9v-2.74h10.26v2.74Zm0,8.85v-2.74h11.82V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M853.11,1098v-14.69H856V1098Zm8.92,0v-8.9a3.36,3.36,0,0,0-.8-2.41,3,3,0,0,0-2.27-.85,3,3,0,0,0-2.19.75,2.82,2.82,0,0,0-.77,2.11l-.3-2.83a5.28,5.28,0,0,1,1.78-2,4.26,4.26,0,0,1,2.43-.73,4.56,4.56,0,0,1,3.7,1.57,6.66,6.66,0,0,1,1.31,4.42V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M873.94,1093.8l3.6-10.49h3L875,1098h-2.18l-5.52-14.69h3Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M883.39,1080.3v-2.88h2.89v2.88Zm0,17.7v-14.69h2.89V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M890.67,1098v-14.69h2.88V1098Zm8.08-11.21a2.37,2.37,0,0,0-1-.71,3.54,3.54,0,0,0-1.35-.24,2.88,2.88,0,0,0-2.13.76,2.84,2.84,0,0,0-.76,2.1l-.29-2.83a5.23,5.23,0,0,1,1.75-2,4.14,4.14,0,0,1,2.38-.74,5.47,5.47,0,0,1,1.82.29,4.1,4.1,0,0,1,1.42.86Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M908.39,1098.22a5.86,5.86,0,0,1-4.47-1.68,6.59,6.59,0,0,1-1.59-4.72v-2.4a6.46,6.46,0,0,1,1.59-4.67,6.86,6.86,0,0,1,9,0,6.46,6.46,0,0,1,1.59,4.67v2.44a6.51,6.51,0,0,1-1.59,4.69A5.9,5.9,0,0,1,908.39,1098.22Zm0-2.75a3,3,0,0,0,2.35-1,3.92,3.92,0,0,0,.83-2.66v-2.44a3.85,3.85,0,0,0-.83-2.64,3.38,3.38,0,0,0-4.68,0,3.8,3.8,0,0,0-.84,2.64v2.44a3.88,3.88,0,0,0,.84,2.66A3,3,0,0,0,908.39,1095.47Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M918.56,1098v-14.69h2.89V1098Zm8.92,0v-8.9a3.36,3.36,0,0,0-.8-2.41,3,3,0,0,0-2.27-.85,3,3,0,0,0-2.19.75,2.82,2.82,0,0,0-.77,2.11l-.3-2.83a5.28,5.28,0,0,1,1.78-2,4.26,4.26,0,0,1,2.43-.73,4.57,4.57,0,0,1,3.7,1.57,6.72,6.72,0,0,1,1.31,4.42V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M934.76,1098v-14.69h2.89V1098Zm8.92,0v-8.9a3.36,3.36,0,0,0-.8-2.41,3,3,0,0,0-2.27-.85,3,3,0,0,0-2.19.75,2.82,2.82,0,0,0-.77,2.11l-.3-2.83a5.28,5.28,0,0,1,1.78-2,4.26,4.26,0,0,1,2.43-.73,4.57,4.57,0,0,1,3.7,1.57,6.72,6.72,0,0,1,1.31,4.42V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M957,1098.22a6.34,6.34,0,0,1-4.76-1.72,6.65,6.65,0,0,1-1.68-4.87V1090a7.34,7.34,0,0,1,1.62-5.08,5.82,5.82,0,0,1,4.56-1.8,5,5,0,0,1,4.3,2,9.37,9.37,0,0,1,1.52,5.72v1h-9.91v-2.33h7.17a5,5,0,0,0-.93-2.79,2.61,2.61,0,0,0-2.15-1,3.12,3.12,0,0,0-2.53,1.08,4.54,4.54,0,0,0-.91,3v1.87a3.82,3.82,0,0,0,1,2.8,3.69,3.69,0,0,0,2.73,1,4.7,4.7,0,0,0,1.74-.35,4.93,4.93,0,0,0,1.54-1l1.9,1.9a7.92,7.92,0,0,1-2.45,1.62A6.87,6.87,0,0,1,957,1098.22Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M966.51,1098v-14.69h2.89V1098Zm8.78,0v-8.9a3.49,3.49,0,0,0-.77-2.41,2.75,2.75,0,0,0-2.16-.85,3,3,0,0,0-2.19.75,2.78,2.78,0,0,0-.77,2.11l-.3-2.83a5.12,5.12,0,0,1,1.78-2,4.25,4.25,0,0,1,2.42-.73,4.39,4.39,0,0,1,3.6,1.57,6.83,6.83,0,0,1,1.28,4.42V1098Zm8.78,0v-8.9a3.4,3.4,0,0,0-.8-2.41,3,3,0,0,0-2.28-.85,2.65,2.65,0,0,0-2.08.82,3.36,3.36,0,0,0-.73,2.32l-.58-2.83a5.65,5.65,0,0,1,1.84-2.26,4.25,4.25,0,0,1,2.5-.8,4.59,4.59,0,0,1,3.71,1.57,6.72,6.72,0,0,1,1.31,4.42V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M997.36,1098.22a6.36,6.36,0,0,1-4.76-1.72,6.65,6.65,0,0,1-1.68-4.87V1090a7.34,7.34,0,0,1,1.62-5.08,5.83,5.83,0,0,1,4.57-1.8,5.06,5.06,0,0,1,4.3,2,9.44,9.44,0,0,1,1.52,5.72v1H993v-2.33h7.16a4.87,4.87,0,0,0-.93-2.79,2.59,2.59,0,0,0-2.14-1,3.14,3.14,0,0,0-2.54,1.08,4.59,4.59,0,0,0-.9,3v1.87a3.78,3.78,0,0,0,1,2.8,3.65,3.65,0,0,0,2.72,1,4.62,4.62,0,0,0,1.74-.35,5.09,5.09,0,0,0,1.55-1l1.89,1.9a7.88,7.88,0,0,1-2.44,1.62A6.89,6.89,0,0,1,997.36,1098.22Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1006.89,1098v-14.69h2.89V1098Zm8.92,0v-8.9a3.36,3.36,0,0,0-.8-2.41,3,3,0,0,0-2.27-.85,3,3,0,0,0-2.19.75,2.82,2.82,0,0,0-.77,2.11l-.3-2.83a5.28,5.28,0,0,1,1.78-2,4.26,4.26,0,0,1,2.43-.73,4.56,4.56,0,0,1,3.7,1.57,6.66,6.66,0,0,1,1.31,4.42V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1022,1085.91v-2.6h6.63v2.6Zm5,12.16a3.19,3.19,0,0,1-2.63-1,4.5,4.5,0,0,1-.82-2.89V1079h2.89v15.18a1.33,1.33,0,0,0,.22.82.7.7,0,0,0,.62.3h1.39v2.74Z",
    transform: "translate(-656 -580.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironnementRecto);
export default __webpack_public_path__ + "static/media/environnement_recto.ed2303feef1dbb3b9824c7ca576ec9c8.svg";
export { ForwardRef as ReactComponent };